import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SystemModuleService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { SystemModuleCrudIndex } from './crud-index';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';

@Component({
  selector: 'app-system-module-select-index',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemModuleService],
})
export class SystemModuleIndexSelectComponent extends SystemModuleCrudIndex {
  override title: string = 'SELECIONE UM MODULO';
  constructor(
    override dialog: MatDialog,
    override service: SystemModuleService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    override permissionService: PermissionService,
    public dialogRefSelect: MatDialogRef<SystemModuleIndexSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
    },
    override router: Router,
    protected override cdr: ChangeDetectorRef,
    protected override authService: AuthService
  ) {
    super(dialog, service, toastService, mediaObserver, router,cdr, authService, permissionService);
    this.dataSelect = data;
  }

  ngOnInit(): void {}

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }
}
